import { useEffect } from "react";

import { useLocation } from "react-router-dom";



const TITLE_MAP: Record<string, string> = {

  "/": "Dashboard",

  "/developers": "Developers",

  "/merge-requests": "Merge Requests",

  "/projects": "Projects",

  "/guidelines": "Guidelines",

  "/quality": "Quality Dashboard",

  "/operations": "Operations",

  "/system-health": "System Health",

  "/development": "Development",

  "/settings": "Settings",

};



export function usePageTitle(): string {

  const { pathname } = useLocation();



  let title = "Kira";

  for (const [path, t] of Object.entries(TITLE_MAP)) {

    if (path === "/" && pathname === "/") { title = t; break; }

    if (path !== "/" && pathname.startsWith(path)) { title = t; break; }

  }



  useEffect(() => {

    document.title = title === "Kira" ? "Kira" : `${title} - Kira`;

  }, [title]);



  return title;

}

